<template>
    <cookie-consent v-if="consentEnabled && isSiteCookieBar" :policy-link="policyLink" />
    <!-- Copies placed in page content would stack banners and open one dialog each. -->
    <div v-else-if="consentEnabled">
        <div v-if="$root.edit" class="text-caption pa-2" v-text="$translate('The cookie dialog is shown automatically on every page and can be removed here')" />
    </div>
    <div :style="[cookieBarBaseStyle, {bottom: mobile ? '56px' : 0}]" v-else-if="!hideCookieBar">
        <div class="d-flex zoezi-row-limit-width pa-8">
            <div>{{ $translate('COOKIEBARMESSAGE') }}
                <span class="z-clickable primary--text text-decoration-underline" @click="showDialog = true">{{$translate('COOKIEBARLINK')}}</span></div> <v-spacer /> <zoezi-button radius="25px" large thin :text="$translate('Allow cookies')" @click="accept" class="ml-2" />

            <v-dialog v-if="mobile" v-model="showDialog" :max-width="mobileDialogMaxWidth" content-class="z-overflow" scrollable>
                <v-btn v-if="showDialog" color="primary" fab small @click="showDialog = false" style="position: absolute; right: 2px; top: calc(5vh - 18px); z-index: 5" ><v-icon color="primarytext">mdi-close</v-icon></v-btn>
                <v-card color="#e9e9e9" min-height="90vh" style="overflow-y: auto">

                    <div class="elevation-4 d-flex" style="background: white">
                        <div class="ma-4" >
                            <v-auto-img :src="$root.siteconfig.appbar.props.logo" style="filter:invert(1);margin: auto" max-width="120px" />
                        </div>

                        <v-spacer />

                        <div class="d-flex align-end mb-2 mr-1">
                            <v-card v-for="section in sections" :key="section.id" class="z-no-focus mr-1" outlined :color="selectedSection == section ? undefined : '#eeeeee'" @click="selectedSection = section" style="border-color: #e5e5e5">
                                <div class="pa-1"><v-icon color="primary">{{section.icon}}</v-icon></div>
                            </v-card>
                        </div>
                    </div>

                    <v-card-text style="min-height: 50vh">

                        <div class="px-8 pt-8 pb-4 d-flex flex-column fill-height">
                            <div class="text-h5 mb-8" v-text="$translate(selectedSection.title)" />

                            <template v-if="selectedSection.id == 'overview'">
                                <p v-text="$translate(selectedSection.text)" />
                            </template>
                            <template v-else-if="selectedSection.id == 'mandatory'">
                                <p v-text="$translate(selectedSection.text)" />
                            </template>
                            <template v-else-if="selectedSection.id == 'thirdparty'">
                                <p v-for="text in selectedSection.text" :key="text" v-text="$translate(text)" />

                                <v-switch :label="$translate(thirdparty ? 'Activated' : 'Inactivated')" v-model="thirdparty"/>
                            </template>
                            <template v-else-if="selectedSection.id == 'policy'">
                                <p v-text="$translate(selectedSection.text)" />

                                <p>{{$translate('More information about')}} <a target="blank" :href="policyLink.href">{{$translate('PRIVACY_POLICY')}}</a></p>
                            </template>
                        </div>

                    </v-card-text>

                    <v-card-actions>
                        <div class="d-flex flex-column fill-width">
                            <v-divider class="mb-4" />
                            <div class="d-flex flex-row" :class="{'justify-center': mobile}">
                                <zoezi-button :text="$translate('Accept all')" @click="accept" radius="25px" large thin />
                            </div>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-else v-model="showDialog" :max-width="secondaryDialogMaxWidth" content-class="z-overflow">
                <v-card color="#e9e9e9" min-height="50vh">
                    <v-btn color="primary" fab @click="showDialog = false" style="position: absolute; right: -28px; top: -28px" ><v-icon color="primarytext" large>mdi-close</v-icon></v-btn>

                    <v-row no-gutters style="min-height: 50vh">
                        <v-col cols=12 md=5 class="elevation-8" style="background-color: white" :class="{'d-flex': mobile}">
                            <div class="ma-4" >
                                <v-auto-img :src="$root.siteconfig.appbar.props.logo" style="filter:invert(1);margin: auto" max-width="120px" />
                            </div>

                            <div v-if="mobile" class="d-flex align-end mb-2">
                                <v-card v-for="section in sections" :key="section.id" class="z-no-focus mx-2" outlined :color="selectedSection == section ? undefined : '#eeeeee'" @click="selectedSection = section" style="border-color: #e5e5e5" height="32px">
                                    <v-icon color="primary">{{section.icon}}</v-icon>
                                </v-card>
                            </div>
                            <template v-else>
                                <v-card v-for="section in sections" :key="section.id" class="ma-4 pa-2 z-no-focus" outlined :color="selectedSection == section ? undefined : '#eeeeee'" @click="selectedSection = section" style="border-color: #e5e5e5">
                                    <div class="text-subtitle-2 text-uppercase d-flex" >
                                        <v-icon large color="primary">{{section.icon}}</v-icon>
                                        <div class="ml-4 d-flex align-center">{{$translate(section.title)}}</div>
                                    </div>
                                </v-card>
                            </template>
                        </v-col>
                        <v-col cols=12 md=7 class="pa-0">
                            <div class="px-8 pt-8 pb-4 d-flex flex-column fill-height">
                                <div class="text-h5 mb-8" v-text="$translate(selectedSection.title)" />

                                <template v-if="selectedSection.id == 'overview'">
                                    <p v-text="$translate(selectedSection.text)" />
                                </template>
                                <template v-else-if="selectedSection.id == 'mandatory'">
                                    <p v-text="$translate(selectedSection.text)" />
                                </template>
                                <template v-else-if="selectedSection.id == 'thirdparty'">
                                    <p v-for="text in selectedSection.text" :key="text" v-text="$translate(text)" />

                                    <v-switch :label="$translate(thirdparty ? 'Activated' : 'Inactivated')" v-model="thirdparty"/>
                                </template>
                                <template v-else-if="selectedSection.id == 'policy'">
                                    <p v-text="$translate(selectedSection.text)" />

                                    <p>{{$translate('More information about')}} <a target="blank" :href="policyLink.href">{{$translate('PRIVACY_POLICY')}}</a></p>
                                </template>

                                <v-spacer />

                                <v-divider class="mb-4" />
                                <div class="d-flex flex-row" :class="{'justify-center': mobile}">
                                    <zoezi-button :text="$translate('Accept all')" @click="accept" radius="25px" large thin />
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import {getCookie, setCookie, grantTrackingConsent, revokeTrackingConsent, hasTrackingConsent, isCookieConsentEnabled} from '../util.js'
import { isHomepageFixHorizontalScrollEnabled } from '../featureFlags'
import CookieConsent from './CookieConsent.vue'
export default {
    name: 'zoezi-cookie-bar',

    components: {CookieConsent},

    zoezi: {
        title: 'Cookie dialog',
        icon: 'mdi-cookie'
    },

    props: {
        policyLink: {
            title: 'Privacy policy',
            type: Object,
            fulltype: 'link',
            default: () => ({href: 'https://zoezi.se/privacy-policy/', newTab: true})
        }
    },

    watch: {
        selectedSection: {
            immediate: true,
            handler(s) {
                if(!s) {
                    this.selectedSection = this.sections[0];
                }
            }
        },
        thirdparty(value) {
            if (value != hasTrackingConsent()) {
                if (value) {
                    grantTrackingConsent();
                } else {
                    revokeTrackingConsent();
                }
            }
        },
        showDialog(show) {
            if (!show) {
                this.setHideCookieBar();
                this.showDialogDelay = false;
            }
        }
    },

    data: () => ({
        hideCookieBar: null,
        thirdparty: false,
        showDialog: false,

        selectedSection: null,

        sections: [
            {id: 'overview', icon: 'mdi-shield-alert-outline', title: 'Overview', text: 'COOKIE_OVERVIEW_TEXT'},
            {id: 'mandatory', icon: 'mdi-check-circle-outline', title: 'Necessary cookies', text: 'COOKIE_NECESSARY_TEXT'},
            {id: 'thirdparty', icon: 'mdi-export', title: 'Cookies from third party', text:
                [
                    'COOKIE_GA_TEXT',
                    'COOKIE_IMPROVEHP_TEXT'
                ]},
            {id: 'policy', icon: 'mdi-file-document-outline', title: 'Cookie Policy', text: 'COOKIE_POLICY_TEXT'}
        ]
    }),

    computed: {
        consentEnabled() {
            return isCookieConsentEnabled();
        },
        isSiteCookieBar() {
            const bar = this.$root.siteconfig && this.$root.siteconfig.cookieBar;
            return !!bar && bar.id === this.$attrs.id;
        },
        mobile() {
            return this.$vuetify.breakpoint.mobile;
        },
        homepageFixHorizontalScrollEnabled() {
            return isHomepageFixHorizontalScrollEnabled(this);
        },
        cookieBarBaseStyle() {
            const style = {
                position: 'fixed',
                backgroundColor: 'white',
                zIndex: 10,
                borderTop: '1px solid #c9c9c9'
            };
            if (this.homepageFixHorizontalScrollEnabled) {
                style.left = 0;
                style.right = 0;
            } else {
                style.width = '100vw';
            }
            return style;
        },
        mobileDialogMaxWidth() {
            const unit = this.homepageFixHorizontalScrollEnabled ? '%' : 'vw';
            return `calc(100${unit} - 44px)`;
        },
        secondaryDialogMaxWidth() {
            if (!this.mobile) {
                return 1200;
            }
            const unit = this.homepageFixHorizontalScrollEnabled ? '%' : 'vw';
            return `calc(100${unit} - 60px)`;
        }
    },

    methods: {
        accept() {
            this.thirdparty = true;
            this.showDialog = false;
            this.setHideCookieBar();
        },
        setHideCookieBar() {
            setCookie('hideCookieBar', 'true', 365*10);
            this.hideCookieBar = true;
        }
    },

    mounted() {
        if (this.consentEnabled) {
            return;
        }
        this.hideCookieBar = !!getCookie('hideCookieBar')
        this.thirdparty = hasTrackingConsent();

        this.$root.$on('setThirdpartyCookieStatus', (accept) => {
            if (accept) {
                this.accept();
            } else {
                this.thirdparty = false;
                this.setHideCookieBar();
            }
        });
    }
}
</script>
